import { config } from 'state/attributeGroup/config'

MK.events.on('attribute:group:clearSelections', (event = {}) => {
  const group = event.target

  group.is = {
    active: true,
    abbreviated: group.attributes.length > config.thresholds.abbreviatedAttributes,
    collapsed: group.is.collapsed, //  || !group.is.selected
    highlighted: false, // group.is.highlighted,
    selected: false
  }

  group.selected = {
    aliases: new Set(),
    attributes: [],
    colors: new Set(),
    productIDs: new Set()
  }

  group.attributes.forEach(attribute => attribute.clearSelections())
})
